module.exports = function() {
  return new Worker(__webpack_public_path__ + "9392d637beaa2a7df019.worker.js");
};